export const GA_MEASUREMENT_ID = 'G-E2JSQ9TBPN';

type GtagWindow = Window & { gtag?: (...args: unknown[]) => void };

/**
 * Envia um evento de busca para o Google Analytics 4.
 * Utiliza o evento padrão 'search' e o parâmetro 'search_term'.
 */
export const trackSearchEvent = (searchTerm: string) => {
  if (typeof window === 'undefined') return;
  const gtag = (window as GtagWindow).gtag;
  if (gtag) {
    gtag('event', 'search', { search_term: searchTerm });
  }
};

/**
 * Envia um evento genérico.
 */
export const trackEvent = (eventName: string, params?: Record<string, unknown>) => {
  if (typeof window === 'undefined') return;
  const gtag = (window as GtagWindow).gtag;
  if (gtag) {
    gtag('event', eventName, params);
  }
};
